/**
 * Feed constants.
 *
 * FEED_EDITOR_CHOICE_CATEGORY maps to the 'playable_feed' editor-choice category.
 * NOTE: 'playable_feed' is a CMS contract value — not a product name. Do not change this
 * string without a corresponding CMS contract update.
 */
export const FEED_EDITOR_CHOICE_CATEGORY = 'playable_feed'

/** Number of editor-choice groups to request per API page. */
export const FEED_PAGE_LIMIT = 10

/** Number of feed items to render in the DOM at once (active ± this value). */
export const FEED_RENDER_WINDOW = 1

/** Number of items ahead/behind active to preload BlendVision metadata. */
export const FEED_METADATA_PRELOAD_WINDOW = 2

/** Minimum intersectionRatio (0–1) for an item to be considered active; >0.5 prevents premature switch while two items share the viewport mid-scroll. */
export const FEED_ACTIVE_RATIO_THRESHOLD = 0.6

/** Peek translate distance in px for the end-of-trailer hint animation. */
export const FEED_PEEK_OFFSET_PX = 56

/** Peek animation duration in milliseconds. */
export const FEED_PEEK_DURATION_MS = 700

/** Duration for mobile Feed metadata and action-rail drawer choreography. */
export const FEED_DRAWER_CHROME_DURATION_MS = 500

/**
 * Tracking query parameters appended to Play Now links.
 * NOTE: 'playable_feed' is a CMS contract value — do not change without BI/analytics alignment.
 */
export const FEED_TRACKING_PARAMS = {
  source: 'playable_feed',
} as const
